/**
 * PURPOSE:
 * Consultar en modo lectura la llave eliminatoria pública del evento 17.
 *
 * RESPONSIBILITIES:
 * - Centralizar la llamada al endpoint existente de la llave.
 * - Normalizar idevent e idsport antes de enviar el request.
 * - No exponer acciones administrativas de sorteo, generación o avance.
 *
 * COLLABORATORS:
 * - Event17PublicBracket.jsx
 * - backend POST /event17bracket/get
 *
 * ROUTE:
 * src/components/Fixture/components/event17PublicBracket.api.js
 */
import axios from "axios";
import API_BASE_URL from "../../../config/config.js";

export async function getEvent17PublicBracket({ idevent, idsport }) {
  const { data } = await axios.post(`${API_BASE_URL}/event17bracket/get`, {
    idevent: Number(idevent),
    idsport: Number(idsport),
  });

  return data;
}
